module.exports = __webpack_public_path__ + "img/index.01034e42.svg";